import { useQuery } from "@tanstack/react-query";
import { useAuthStore } from "@/store/authStore";
import { Permission } from "@/types";
import { adminService, type PlatformStats } from "@/services/adminService";

/** Keep in sync with `GET /admin/stats` require_permissions(..., match="any"). */
export const ADMIN_STATS_SECTION_PERMISSIONS = [
  Permission.STATS_READ,
  Permission.SELLERS_READ_ANY,
  Permission.PARTNERS_READ_ANY,
  Permission.ACTIVITIES_READ_ANY,
  Permission.ACTIVITIES_MANAGE_ANY,
  Permission.HOUSES_READ_ANY,
] as const;

export function useAdminDashboardData() {
  const { hasPermission } = useAuthStore();
  const canFetch = ADMIN_STATS_SECTION_PERMISSIONS.some((permission) =>
    hasPermission(permission),
  );
  const {
    data: stats,
    isLoading,
    error,
  } = useQuery({
    queryKey: ["admin", "stats"],
    queryFn: () => adminService.getStats(),
    enabled: canFetch,
  });

  return {
    stats: stats ?? null,
    canFetch,
    isLoading: canFetch && isLoading,
    error: canFetch ? error : null,
  };
}

export type { PlatformStats };
